import React, { useState, useEffect } from 'react';
import cx from 'classnames';
import { Button } from '../';
// constants
const STATUS_LOADING = 'loading';
const STATUS_SAVED = 'saved';
// show saved button for 2 seconds
const SUCCESS_VISIBLE_TIME = 5000;
export const CommentBox = ({ title, inputText, buttonText, successButtonText, onSubmit, status, textLimit, readOnly = true, canSave = true, onChange, hideSubmitButton, }) => {
    const [isValid, setisValid] = useState(false);
    const [isDirty, setisDirty] = useState(false);
    const [text, setText] = useState(inputText);
    const [saveStatus, setSaveStatus] = useState(false);
    useEffect(() => {
        if (status === STATUS_SAVED) {
            setSaveStatus(true);
            setTimeout(() => {
                setSaveStatus(false);
            }, SUCCESS_VISIBLE_TIME);
        }
    }, [status]);
    // update component when inputText changes
    useEffect(() => {
        setText(inputText);
    }, [inputText]);
    const handleChange = (text) => {
        if (textLimit) {
            text = text.slice(0, textLimit);
        }
        if (onChange) {
            onChange(text);
        }
        setText(text);
        setisValid(true);
        setisDirty(text !== inputText);
    };
    const buttonContent = saveStatus && successButtonText ? successButtonText : buttonText;
    return (React.createElement("div", { className: cx('comment-box', { 'comment-box--read-only': readOnly }) },
        React.createElement("div", { className: "comment-box_header" },
            React.createElement("h5", null, title)),
        React.createElement("form", { className: "comment-box_form", onSubmit: e => {
                e.preventDefault();
                if (onSubmit) {
                    setisDirty(false);
                    onSubmit(text);
                }
            } },
            React.createElement("textarea", { value: text, rows: 15, cols: 60, disabled: status === STATUS_LOADING, style: { resize: 'none' }, "aria-label": `Comments`, className: "comment-box_textarea", onChange: e => handleChange(e.target.value), readOnly: readOnly }),
            !readOnly && !hideSubmitButton && (React.createElement(Button, { type: "submit", style: saveStatus ? 'success' : 'primary', disabled: (!canSave || !isValid || !isDirty) && status !== STATUS_LOADING, loading: status === STATUS_LOADING, className: "comment-box_submit" }, buttonContent)))));
};
//# sourceMappingURL=CommentBox.js.map